export default __webpack_public_path__ + "static/Typography-cc9c604e06341341f7f6bc7a9a80b35c.png";